var z = Object.defineProperty;
var X = (y, f, e) => f in y ? z(y, f, { enumerable: !0, configurable: !0, writable: !0, value: e }) : y[f] = e;
var b = (y, f, e) => X(y, typeof f != "symbol" ? f + "" : f, e);
import { jsx as i, jsxs as n, Fragment as M } from "react/jsx-runtime";
import g, { Component as B } from "react";
import q from "react-dom";
import H from "./contact-channels66.js";
import W from "./contact-channels67.js";
import x from "./contact-channels68.js";
import { useTranslations as K } from "./contact-channels43.js";
import { useRecaptchaContext as G } from "./contact-channels69.js";
import $ from "./contact-channels18.js";
import { Spinner as L, DropdownOption as C, Column as h, Row as c, ModalDialog as Q, ModalDialogContent as V, ModalDialogCloseButton as J, Box as D, Typography as k, ModalDialogBody as Y, GridContainer as O, StandardForm as Z, FormField as v, FormLabel as S, FormInputGroup as _, Dropdown as j, FormError as N, Link as A, FlexBox as T, ModalDialogButtons as ee, Button as F, Icon as te, FormLabelOptional as ie, TextInput as R, TextArea as se, FormHelper as ae, Divider as ne, AlertBox as U, AlertBoxDismissButton as le } from "@vp/swan";
import o from "./contact-channels14.js";
import p from "./contact-channels15.js";
/* empty css                   */
class re extends B {
  constructor(e) {
    super(e);
    b(this, "emailContainerRef", g.createRef());
    b(this, "fieldRefs", {
      subject: g.createRef(),
      valueIssue: g.createRef(),
      orderNumber: g.createRef(),
      phoneNumber: g.createRef(),
      firstName: g.createRef(),
      lastName: g.createRef(),
      email: g.createRef(),
      company: g.createRef(),
      comment: g.createRef()
    });
    b(this, "handleOnSubjectChange", (e) => {
      this.setState({ shouldShowSelfService: !1 }), this.setState({ reconsiderLink: !1 }), this.setState({ lastIssue: "" }), this.handleOnChange(e);
    });
    b(this, "handleOnChange", async (e) => {
      var t;
      switch (e.target.name) {
        case "file": {
          const s = e.target;
          if (!s.files || s.files.length === 0) break;
          const a = s.files[0];
          if (s.value = "", this.state.files.findIndex((l) => l.name === a.name) === -1 && this.state.files.length < 3 && this.validateFile(a.name, a.size))
            if (this.setState({
              inputError: null
            }), this.getInputFileList(!0), (t = this.props.assetStore) != null && t.uploadAsset)
              try {
                const l = await this.props.assetStore.uploadAsset(a);
                this.setState((u) => (u.files.push(a), u.uploadedFiles.push({
                  publicUrl: l.publicUrl,
                  fileName: l.fileName,
                  name: l.name
                }), this.getInputFileList(!1), u));
              } catch (l) {
                console.error("Error uploading file:", l), this.setState((u) => (u.files.push(a), u.uploadedFiles.push({
                  publicUrl: `File attachment upload failed: ${a.name}`,
                  fileName: a.name,
                  name: a.name
                }), this.getInputFileList(!1), u));
              }
            else
              this.setState((l) => (l.files.push(a), l.uploadedFiles.push({
                publicUrl: "",
                fileName: a.name,
                name: a.name
              }), this.getInputFileList(!1), l));
          break;
        }
        default:
          this.setState((s) => ({
            ...s,
            [e.target.name]: new o(e.target.value)
          }));
      }
    });
    b(this, "trackEvent", (e, t, s, a = " ") => {
      console.log("Track event:", { action: e, category: t, label: s, eventDetail: a });
    });
    b(this, "handleOnSubmit", async (e) => {
      var m;
      e.preventDefault(), e.stopPropagation(), this.setState({ shouldShowSelfService: !1 });
      const { lastIssue: t, shouldShowSelfService: s, issueMapping: a } = this.state, r = a[t];
      if (r && this.setState({ reconsiderLink: !0 }), s && this.trackEvent(r.action.deflection, r.category.email, r.labels.email, r.submitDetail), s || this.validateFields() === !1)
        return;
      if (!await this.props.getRecaptchaToken("HelpCenterEmailSubmit")) {
        this.getErrorAlert(4);
        return;
      }
      if (this.props.onSubmit) {
        this.setState({
          load: this.getLoader(),
          shown: !1,
          alert: null
        });
        const w = this.state.subjects.filter((d) => d.id === this.state.subject.value), E = {
          email: this.state.email.value.trim(),
          firstName: this.state.firstName.value.trim(),
          lastName: this.state.lastName.value.trim(),
          subject: ((m = w[0]) == null ? void 0 : m.value) + " - " + this.state.valueIssue.value,
          comment: this.state.comment.value.trim(),
          companyName: this.state.company.value ? this.state.company.value.trim() : "",
          orderNumber: this.state.orderNumber.value ? this.state.orderNumber.value.trim() : "",
          phoneNumber: this.state.phoneNumber.value ? this.state.phoneNumber.value.trim() : "",
          assets: this.state.uploadedFiles.filter(
            (d) => d.publicUrl && d.publicUrl !== "" && !d.publicUrl.startsWith("File attachment upload failed")
          ).map((d) => ({
            publicUrl: d.publicUrl,
            fileName: d.fileName,
            name: d.name
          }))
        };
        console.log("Email form data being submitted:", JSON.stringify(E, null, 2));
        try {
          (await this.props.onSubmit(E)).success ? this.getSuccessAlert({
            caseId: "submitted",
            emailAddress: E.email,
            caseNumber: "pending"
          }) : (this.getErrorAlert(5), this.setState({ shown: !0 }));
        } catch (d) {
          console.error("Error submitting form:", d), this.getErrorAlert(5), this.setState({ shown: !0 });
        } finally {
          this.setState({ load: null });
        }
        return;
      }
      return this.handleClick(), setTimeout(() => {
        this.getSuccessAlert({
          caseId: "test-case-id",
          emailAddress: this.state.email.value,
          caseNumber: "TEST-123"
        }), this.setState({ load: null });
      }, 2e3), !1;
    });
    b(this, "handleRemoveFile", async (e) => {
      const t = e.target, s = this.state.files.findIndex((a) => a.name === t.id);
      this.setState((a) => (s !== -1 && (a.files.splice(s, 1), a.uploadedFiles.splice(s, 1)), this.getInputFileList(!1), a));
    });
    b(this, "handleUpload", (e) => {
      e.preventDefault();
      const t = document.getElementById("file");
      t == null || t.click();
    });
    const t = (a, r = "", l) => {
      const u = a.replace(/^[^:]+:/, "");
      if (l != null && l.returnObjects && u === "subjects")
        return [
          { id: "", value: String(e.t("email.fields.subject.options.option_please_select")) },
          { id: "Existing Order", value: String(e.t("email.fields.subject.options.option_existing_order")) },
          { id: "New Order", value: String(e.t("email.fields.subject.options.option_new_order")) },
          { id: "My Account", value: String(e.t("email.fields.subject.options.option_my_account")) },
          {
            id: "Website Subscription",
            value: String(e.t("email.fields.subject.options.option_website_subscription"))
          }
        ];
      const m = e.t(u);
      return typeof m == "string" ? m : r || u;
    }, s = (a, r = "") => {
      const l = t(a, r);
      return typeof l == "string" ? l : r;
    };
    this.state = {
      shouldShowSelfService: !1,
      lastIssue: "",
      reconsiderUrl: "",
      reconsiderLink: !1,
      showOrderNumber: !1,
      files: [],
      uploadedFiles: [],
      email: new o(),
      firstName: new o(),
      lastName: new o(),
      subject: new o(),
      valueIssue: new o(),
      comment: new o(),
      orderNumber: new o(),
      phoneNumber: new o(),
      company: new o(),
      tenant: e.tenant,
      locale: e.locale,
      slaMessage: e.contactChannels.email.slaMsg,
      formMessage: e.contactChannels.email.formMsg,
      value: null,
      shown: !0,
      alert: null,
      load: null,
      inputError: null,
      fileListUI: null,
      fileTypeAccepted: !0,
      fileSizeAccepted: !0,
      subjects: t("subjects", "", { returnObjects: !0 }),
      commonTrackingData: {
        pageSection: "Help Center",
        pageStage: "Customer Care",
        pageName: "Help Center:Email Form"
      },
      issueMapping: {
        "Delivery damage": {
          reconsiderSubmit: "Delivery Damage",
          submitDetail: "Delivery Damage",
          eventDetail: "Form Redirect - Email - Delivery Damage",
          emailSubmit: " ",
          labels: {
            email: "Replacement - Email Continue",
            deflection: "Replacement - Deflection",
            reconsider: "Replacement - Deflection Reconsidered"
          },
          category: {
            deflection: "Help Center - Self Service",
            email: "Global Email"
          },
          action: {
            deflection: "Button Clicked",
            email: "CARE Case Submitted"
          }
        },
        "Printing quality": {
          reconsiderSubmit: "Printing Quality",
          submitDetail: "Printing Quality",
          eventDetail: "Form Redirect - Email - Printing Quality",
          emailSubmit: " ",
          labels: {
            email: "Replacement - Email Continue",
            deflection: "Replacement - Deflection",
            reconsider: "Replacement - Deflection Reconsidered"
          },
          category: {
            deflection: "Help Center - Self Service",
            email: "Global Email"
          },
          action: {
            deflection: "Button Clicked",
            email: "CARE Case Submitted"
          }
        },
        missing_order: {
          reconsiderSubmit: "Track Order",
          submitDetail: " ",
          eventDetail: " ",
          emailSubmit: " ",
          labels: {
            email: "Track Order - Email Continue",
            deflection: "Track Order - Deflection",
            reconsider: "Track Order - Deflection Reconsidered"
          },
          category: {
            deflection: "Global Email",
            email: "Global Email"
          },
          action: {
            deflection: "Button Clicked",
            email: "CARE Case Submitted"
          }
        }
      },
      issues_1: [
        {
          id: "missing_order",
          value: s("email.fields.issue.options.option_order_not_arrived")
        },
        { id: "VAT invoice", value: s("email.fields.issue.options.option_vat_invoice") },
        {
          id: "Document error",
          value: s("email.fields.issue.options.option_document_error")
        },
        {
          id: "Printing quality",
          value: s("email.fields.issue.options.option_printing_quality")
        },
        {
          id: "Delivery damage",
          value: s("email.fields.issue.options.option_delivery_damage")
        },
        { id: "Cancel order", value: s("email.fields.issue.options.option_cancel_order") },
        { id: "Change order", value: s("email.fields.issue.options.option_change_order") },
        { id: "Other", value: s("email.fields.issue.options.option_other") }
      ],
      issues_2: [
        {
          id: "Document assistance",
          value: s("email.fields.issue.options.option_document_assitance")
        },
        {
          id: "Order assistance",
          value: s("email.fields.issue.options.option_order_assitance")
        },
        {
          id: "Product/Pricing/Service question",
          value: s("email.fields.issue.options.option_product_pricing_service_question")
        },
        { id: "Other", value: s("email.fields.issue.options.option_other") }
      ],
      issues_3: [
        {
          id: "Reset password",
          value: s("email.fields.issue.options.option_reset_password")
        },
        {
          id: "Unsubscribe from emails",
          value: s("email.fields.issue.options.option_unsubscribe_from_emails")
        },
        { id: "Other", value: s("email.fields.issue.options.option_other") }
      ],
      issues_4: [
        {
          id: "Creating a website",
          value: s("email.fields.issue.options.option_creating_website")
        },
        {
          id: "Existing website",
          value: s("email.fields.issue.options.option_existing_website")
        },
        {
          id: "Cancel website",
          value: s("email.fields.issue.options.option_cancel_website")
        },
        { id: "Other", value: s("email.fields.issue.options.option_other") }
      ],
      issues_5: [
        {
          id: "Creating an email subscription",
          value: s("email.fields.issue.options.option_creating_email_subscription")
        },
        {
          id: "Existing email subscription",
          value: s("email.fields.issue.options.option_existing_email_subscription")
        },
        {
          id: "Cancel email subscription",
          value: s("email.fields.issue.options.option_cancel_email_subscription")
        },
        { id: "Other", value: s("email.fields.issue.options.option_other") }
      ]
    }, this.handleChange = this.handleChange.bind(this), this.handleChangeIssue = this.handleChangeIssue.bind(this), this.handleClick = this.handleClick.bind(this), this.handleOnRedirectSubmit = this.handleOnRedirectSubmit.bind(this), this.handleOnReconsiderSubmit = this.handleOnReconsiderSubmit.bind(this);
  }
  async componentDidMount() {
    await this.getCustomerProfile();
  }
  async componentDidUpdate(e) {
    var t, s, a, r;
    ((s = (t = e.auth) == null ? void 0 : t.identity) == null ? void 0 : s.isSignedIn) !== ((r = (a = this.props.auth) == null ? void 0 : a.identity) == null ? void 0 : r.isSignedIn) && await this.getCustomerProfile();
  }
  async getCustomerProfile() {
    var s, a, r, l;
    const e = (a = (s = this.props.auth) == null ? void 0 : s.identity) == null ? void 0 : a.isSignedIn, t = (l = (r = this.props.auth) == null ? void 0 : r.identity) == null ? void 0 : l.authorizationHeader;
    if (t && e)
      try {
        const m = await new $().getCustomerProfile(t);
        m && this.setState((w) => ({
          firstName: m.firstName ? new o(m.firstName) : w.firstName,
          lastName: m.lastName ? new o(m.lastName) : w.lastName,
          email: m.email ? new o(m.email) : w.email
        }));
      } catch (u) {
        console.error("Error fetching customer profile:", u);
      }
  }
  handleChange(e) {
    this.setState({ value: e.target.value });
  }
  handleChangeIssue(e) {
    const t = this.state.subject.value === "Existing Order" && this.state.issues_1.filter((a) => a.value === e.target.value && !["VAT invoice", "Change order"].includes(a.id)).length > 0, s = this.state.subject.value === "Existing Order" && ["missing_order"].includes(e.target.value);
    this.setState({ showOrderNumber: t }), this.setState({ shouldShowSelfService: s }), this.setState({ lastIssue: e.target.value }), t || this.setState({ orderNumber: new o() }), this.setState({ reconsiderLink: !1 }), this.setState({
      valueIssue: new o(e.target.value)
    });
  }
  validateFile(e, t) {
    const s = e.lastIndexOf(".") + 1, a = e.substr(s, e.length).toLowerCase();
    if (![
      "pdf",
      "ai",
      "psd",
      "bmp",
      "gif",
      "jpg",
      "jpeg",
      "ppt",
      "pptx",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "pcx",
      "pic",
      "pict",
      "pct",
      "png",
      "ps",
      "tif",
      "tiff"
    ].includes(a))
      return this.getErrorAlert(1), !1;
    const l = 6 * 1024 * 1024;
    return t > l ? (this.getErrorAlert(2), !1) : !0;
  }
  validateFields() {
    var s;
    const e = (a, r = "") => {
      const l = a.replace(/^[^:]+:/, "");
      return String(this.props.t(l)) || r;
    }, t = this.state;
    return p.validateSubject(t.subject.value) ? p.validateIssue(t.valueIssue.value) ? p.validateOrderNumber(t.orderNumber.value) ? p.validatePhoneNumber(t.phoneNumber.value) ? p.validateNameEmpty(t.firstName.value) ? p.validateNameFormat(t.firstName.value) ? p.validateNameEmpty(t.lastName.value) ? p.validateNameFormat(t.lastName.value) ? p.validateEmailAddressEmpty(t.email.value) ? p.validateEmailExistingAt(t.email.value) ? p.validateEmailAddress(t.email.value) ? p.validateCompany(t.company.value) ? p.validateCommentEmpty(t.comment.value) ? p.validateCommentFormat(t.comment.value) ? ((s = this.emailContainerRef.current) == null || s.focus(), !0) : (this.setState({
      comment: new o(t.comment.value).setError(e("email.fields.comments.errors.invalid_format"))
    }), this.focusField("comment"), !1) : (this.setState({
      comment: new o(t.comment.value).setError(e("email.fields.comments.errors.empty"))
    }), this.focusField("comment"), !1) : (this.setState({
      company: new o(t.company.value).setError(e("email.fields.company_name.errors.invalid_format"))
    }), this.focusField("company"), !1) : (this.setState({
      email: new o(t.email.value).setError(e("email.fields.email.errors.invalid_format"))
    }), this.focusField("email"), !1) : (this.setState({
      email: new o(t.email.value).setError(e("email.fields.email.errors.missing_at"))
    }), this.focusField("email"), !1) : (this.setState({
      email: new o(t.email.value).setError(e("email.fields.email.errors.empty"))
    }), this.focusField("email"), !1) : (this.setState({
      lastName: new o(t.lastName.value).setError(e("email.fields.last_name.errors.invalid_format"))
    }), this.focusField("lastName"), !1) : (this.setState({
      lastName: new o(t.lastName.value).setError(e("email.fields.last_name.errors.empty"))
    }), this.focusField("lastName"), !1) : (this.setState({
      firstName: new o(t.firstName.value).setError(e("email.fields.first_name.errors.invalid_format"))
    }), this.focusField("firstName"), !1) : (this.setState({
      firstName: new o(t.firstName.value).setError(e("email.fields.first_name.errors.empty"))
    }), this.focusField("firstName"), !1) : (this.setState({
      phoneNumber: new o(t.phoneNumber.value).setError(
        e("email.fields.phone_number.errors.invalid_format")
      )
    }), this.focusField("phoneNumber"), !1) : (this.setState({
      orderNumber: new o(t.orderNumber.value).setError(
        e("email.fields.order_number.errors.invalid_format")
      )
    }), this.focusField("orderNumber"), !1) : (this.setState({
      valueIssue: new o(t.valueIssue.value).setError(e("email.fields.issue.errors.empty"))
    }), this.focusField("valueIssue"), !1) : (this.setState({
      subject: new o(t.subject.value).setError(e("email.fields.subject.errors.empty"))
    }), this.focusField("subject"), !1);
  }
  focusField(e) {
    const t = this.fieldRefs[e];
    if (t != null && t.current)
      if (t.current instanceof HTMLElement && t.current.focus)
        t.current.focus();
      else {
        const s = q.findDOMNode(t.current);
        s && s instanceof HTMLElement && s.focus();
      }
  }
  handleClick() {
    this.setState({
      shown: !this.state.shown
    }), this.setState({
      load: this.getLoader()
    }), this.setState({
      alert: null
    });
  }
  handleOnRedirectSubmit() {
    const { lastIssue: e, shouldShowSelfService: t, issueMapping: s } = this.state, a = s[e];
    if (t)
      this.trackEvent(a.action.deflection, a.category.deflection, a.labels.deflection, a.eventDetail);
    else
      return;
    const r = this.getWebsiteUrl() + "od";
    this.setState({ reconsiderUrl: r }), window.location.href = r;
  }
  handleOnReconsiderSubmit() {
    const { lastIssue: e, shouldShowSelfService: t, issueMapping: s } = this.state;
    if (!t) {
      const a = s[e];
      this.trackEvent(a.action.deflection, a.category.deflection, a.labels.reconsider, a.eventDetail);
    }
  }
  getInputFileList(e) {
    const t = (a, r = "") => {
      const l = a.replace(/^[^:]+:/, "");
      return String(this.props.t(l)) || r;
    }, s = () => /* @__PURE__ */ i(c, { children: /* @__PURE__ */ n(h, { paddingRight: "5", span: 12, spanXs: 10, spanSm: 12, spanMd: 12, spanLg: 12, children: [
      this.state.files.map((a, r) => /* @__PURE__ */ i("p", { children: /* @__PURE__ */ i(
        F,
        {
          className: "stylized-button-skin-clear-selection stylized-button-skin-launcher",
          id: a.name,
          skin: "secondary",
          size: "mini",
          type: "button",
          value: "delete",
          onClick: this.handleRemoveFile,
          children: a.name
        }
      ) }, r)),
      e && /* @__PURE__ */ i(F, { disabled: !0, id: "loadingFile", size: "mini", children: /* @__PURE__ */ i(L, { size: "tiny", accessibleText: t("email.buttons.attach_files.loading") }) })
    ] }) }, "file-list");
    this.state.files.length > 0 || e ? this.setState({
      fileListUI: s()
    }) : this.setState({
      fileListUI: null
    });
  }
  getErrorAlert(e) {
    const t = (r, l = "") => {
      const u = r.replace(/^[^:]+:/, "");
      return String(this.props.t(u)) || l;
    };
    let s = "";
    switch (e) {
      case 1:
        s = t("email.buttons.attach_files.errors.error_file_type");
        break;
      case 2:
        s = t("email.buttons.attach_files.errors.error_file_size");
        break;
      case 3:
        s = t("messages.error.description");
        break;
      case 4:
        s = t("email.buttons.recaptcha_error");
        break;
      default:
        s = "";
        break;
    }
    const a = () => /* @__PURE__ */ n(U, { skin: "error", children: [
      /* @__PURE__ */ i("p", { className: void 0, children: s }),
      /* @__PURE__ */ i(le, { accessibleText: "X" })
    ] }, "error_alert");
    this.setState({
      inputError: a()
    });
  }
  getSuccessAlert(e) {
    const t = (a, r = "") => {
      const l = a.replace(/^[^:]+:/, "");
      return String(this.props.t(l)) || r;
    }, s = () => /* @__PURE__ */ i(D, { p: 1, children: /* @__PURE__ */ i(U, { skin: "success", children: /* @__PURE__ */ n("p", { className: void 0, children: [
      t("messages.success.title"),
      /* @__PURE__ */ i("br", {}),
      x(t("messages.success.description1")),
      /* @__PURE__ */ i("span", { className: void 0, children: ` ${e.emailAddress} ` }),
      x(t("messages.success.description2"))
    ] }) }, "success_alert") });
    this.setState({
      alert: s()
    });
  }
  getLoader() {
    return /* @__PURE__ */ i(L, { size: "super", accessibleText: ((t, s = "") => {
      const a = t.replace(/^[^:]+:/, "");
      return String(this.props.t(a)) || s;
    })("search_results.preloader_accessibility_label") });
  }
  getWebsiteUrl() {
    return typeof window < "u" && window.location ? `${window.location.protocol}//${window.location.hostname}/` : "";
  }
  ListIssue(e) {
    switch (e) {
      case "Existing Order":
        return this.state.issues_1.map(
          (t) => t.value ? /* @__PURE__ */ i(C, { id: t.id, value: t.id, children: t.value }, t.id) : null
        );
      case "New Order":
        return this.state.issues_2.map(
          (t) => t.value ? /* @__PURE__ */ i(C, { id: t.id, value: t.id, children: t.value }, t.id) : null
        );
      case "My Account":
        return this.state.issues_3.map(
          (t) => t.value ? /* @__PURE__ */ i(C, { id: t.id, value: t.id, children: t.value }, t.id) : null
        );
      case "Website Subscription":
        return this.state.issues_4.map(
          (t) => t.value ? /* @__PURE__ */ i(C, { id: t.id, value: t.id, children: t.value }, t.id) : null
        );
      default:
        return [];
    }
  }
  render() {
    const e = (d, I = "") => {
      const P = d.replace(/^[^:]+:/, "");
      return String(this.props.t(P)) || I;
    }, s = this.props.proadvantageType !== "";
    let a = "/oh";
    if (typeof window < "u") {
      const d = W(window);
      if (window.location && window.location.pathname) {
        const I = window.location.pathname.split("/")[1];
        I.length === 2 && (a = d.sanitize(`/${I}/oh`));
      }
    }
    const r = this.state.subjects.map((d) => /* @__PURE__ */ i(C, { value: d.id, children: d.value }, d.id)), { shouldShowSelfService: l, reconsiderLink: u } = this.state, m = l && this.props.locale.toLowerCase() === "en-us", w = (this.state.shown, void 0), E = this.state.shown ? {} : { display: "none" };
    return /* @__PURE__ */ i("div", { className: void 0, children: /* @__PURE__ */ i(h, { paddingRight: "2", span: 12, spanXs: 12, spanSm: 12, spanMd: 12, spanLg: 12, children: s ? null : /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i(M, { children: /* @__PURE__ */ i(Q, { isOpen: this.props.isModalOpen, onRequestDismiss: () => this.props.closeModal(), children: /* @__PURE__ */ n(V, { children: [
      /* @__PURE__ */ i(J, {}),
      /* @__PURE__ */ n(D, { pl: 6, mt: 8, children: [
        /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i("div", { style: { display: "flex" }, ref: this.emailContainerRef, children: /* @__PURE__ */ i(k, { fontSkin: "title-section", pb: 5, children: e("email.title") }) }) }),
        /* @__PURE__ */ i(Y, { children: /* @__PURE__ */ n(O, { children: [
          /* @__PURE__ */ i(c, { paddingRight: "5", pb: 6, children: /* @__PURE__ */ i(k, { fontSkin: "title-item", children: this.state.slaMessage }) }),
          /* @__PURE__ */ i(c, { paddingRight: "5", children: /* @__PURE__ */ i("div", { className: w, children: /* @__PURE__ */ i(k, { fontSkin: "body-standard", children: this.state.formMessage }) }) }),
          /* @__PURE__ */ n(c, { paddingRight: "5", children: [
            /* @__PURE__ */ i(c, { paddingTop: "2", style: { width: "100%" }, children: /* @__PURE__ */ n(h, { span: 12, spanXs: 12, spanSm: 12, spanMd: 12, spanLg: 12, children: [
              this.state.alert,
              this.state.load
            ] }) }),
            /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i("div", { style: E, children: /* @__PURE__ */ i(
              Z,
              {
                className: void 0,
                method: "post",
                onSubmit: this.handleOnSubmit,
                id: "email-widget-form",
                children: /* @__PURE__ */ i(c, { children: /* @__PURE__ */ n(h, { span: 12, spanXs: 12, spanSm: 12, spanMd: 12, spanLg: 12, marginTop: "8", children: [
                  /* @__PURE__ */ n(c, { children: [
                    /* @__PURE__ */ i(h, { paddingRight: "5", span: 6, spanXs: 12, spanSm: 6, spanMd: 6, spanLg: 6, children: /* @__PURE__ */ n(v, { children: [
                      /* @__PURE__ */ n(S, { mb: 3, className: void 0, children: [
                        e("email.fields.subject.title"),
                        /* @__PURE__ */ i("span", { "aria-hidden": "true", children: "*" })
                      ] }),
                      /* @__PURE__ */ n(_, { className: void 0, children: [
                        /* @__PURE__ */ i(
                          j,
                          {
                            id: "subject",
                            name: "subject",
                            "aria-required": "true",
                            fullWidth: !0,
                            value: this.state.subject.value,
                            onChange: this.handleOnSubjectChange,
                            ref: this.fieldRefs.subject,
                            children: r
                          }
                        ),
                        this.state.subject.error ? /* @__PURE__ */ i(N, { children: this.state.subject.errorMessage }) : null
                      ] })
                    ] }) }),
                    /* @__PURE__ */ i(h, { paddingRight: "5", span: 6, spanXs: 12, spanSm: 6, spanMd: 6, spanLg: 6, children: /* @__PURE__ */ n(v, { children: [
                      /* @__PURE__ */ n(S, { className: void 0, children: [
                        e("email.fields.issue.title"),
                        /* @__PURE__ */ i("span", { "aria-hidden": "true", children: "*" })
                      ] }),
                      /* @__PURE__ */ n(_, { className: void 0, children: [
                        /* @__PURE__ */ n(
                          j,
                          {
                            id: "issue",
                            name: "issue",
                            "aria-required": "true",
                            fullWidth: !0,
                            value: this.state.valueIssue.value,
                            onChange: this.handleChangeIssue,
                            ref: this.fieldRefs.valueIssue,
                            children: [
                              /* @__PURE__ */ i(C, { value: "", children: e("email.fields.issue.options.option_please_select") }),
                              this.ListIssue(this.state.subject.value)
                            ]
                          }
                        ),
                        this.state.valueIssue.error ? /* @__PURE__ */ i(N, { children: this.state.valueIssue.errorMessage }) : null
                      ] })
                    ] }) })
                  ] }),
                  u && this.props.locale.toLowerCase() === "en-us" && /* @__PURE__ */ i(
                    A,
                    {
                      pb: 4,
                      onClick: this.handleOnReconsiderSubmit,
                      href: "https://www.vistaprint.com/od",
                      children: e("email.buttons.send_email.order_reconsider_title")
                    }
                  ),
                  m ? /* @__PURE__ */ n(M, { children: [
                    /* @__PURE__ */ i(
                      T,
                      {
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        pb: "2",
                        pt: "3",
                        children: /* @__PURE__ */ i(k, { fontSize: "small", fontWeight: "bold", textAlign: "center", children: e("email.buttons.send_email.order_tracking_description") })
                      }
                    ),
                    /* @__PURE__ */ i(O, { children: /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i(h, { span: 12, children: /* @__PURE__ */ i(ee, { children: /* @__PURE__ */ n(
                      F,
                      {
                        skin: "primary",
                        id: "submitbtn",
                        "aria-label": e("email.buttons.send_email.order_tracking_title"),
                        width: "full-width",
                        type: "button",
                        value: "Send",
                        onClick: this.handleOnRedirectSubmit,
                        children: [
                          /* @__PURE__ */ i("span", { children: e("email.buttons.send_email.order_tracking_title") }),
                          /* @__PURE__ */ i(te, { iconType: "arrowRight", size: "20p" })
                        ]
                      }
                    ) }) }) }) })
                  ] }) : /* @__PURE__ */ n(M, { children: [
                    this.state.showOrderNumber ? /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i(
                      h,
                      {
                        paddingRight: "5",
                        span: 6,
                        spanXs: 12,
                        spanSm: 6,
                        spanMd: 6,
                        spanLg: 6,
                        children: /* @__PURE__ */ n(v, { children: [
                          /* @__PURE__ */ n(S, { className: void 0, children: [
                            e("email.fields.order_number.title"),
                            " ",
                            /* @__PURE__ */ i(ie, { children: e("email.optional") })
                          ] }),
                          /* @__PURE__ */ n(_, { className: void 0, children: [
                            /* @__PURE__ */ i(
                              R,
                              {
                                id: "orderNumber",
                                name: "orderNumber",
                                value: this.state.orderNumber.value,
                                onChange: this.handleOnChange,
                                ref: this.fieldRefs.orderNumber
                              }
                            ),
                            /* @__PURE__ */ n("p", { className: void 0, children: [
                              e("email.fields.order_number.description1"),
                              /* @__PURE__ */ i("br", { className: void 0 }),
                              e("email.fields.order_number.description2"),
                              /* @__PURE__ */ i(A, { href: a, target: "_blank", rel: "noreferrer", children: e("email.fields.order_number.link-text") }),
                              e("email.fields.order_number.description3")
                            ] }),
                            this.state.orderNumber.error ? /* @__PURE__ */ i(N, { children: this.state.orderNumber.errorMessage }) : null
                          ] })
                        ] })
                      }
                    ) }) : null,
                    /* @__PURE__ */ n(c, { children: [
                      /* @__PURE__ */ i(
                        h,
                        {
                          paddingRight: "5",
                          span: 6,
                          spanXs: 12,
                          spanSm: 6,
                          spanMd: 6,
                          spanLg: 6,
                          children: /* @__PURE__ */ n(v, { children: [
                            /* @__PURE__ */ n(S, { className: void 0, children: [
                              e("email.fields.first_name.title"),
                              /* @__PURE__ */ i("span", { "aria-hidden": "true", children: "*" })
                            ] }),
                            /* @__PURE__ */ n(_, { className: void 0, children: [
                              /* @__PURE__ */ i(
                                R,
                                {
                                  id: "firstName",
                                  name: "firstName",
                                  onChange: this.handleOnChange,
                                  value: this.state.firstName.value,
                                  "aria-required": "true",
                                  ref: this.fieldRefs.firstName
                                }
                              ),
                              this.state.firstName.error ? /* @__PURE__ */ i(N, { children: this.state.firstName.errorMessage }) : null
                            ] })
                          ] })
                        }
                      ),
                      /* @__PURE__ */ i(
                        h,
                        {
                          paddingRight: "5",
                          span: 6,
                          spanXs: 12,
                          spanSm: 6,
                          spanMd: 6,
                          spanLg: 6,
                          children: /* @__PURE__ */ n(v, { children: [
                            /* @__PURE__ */ n(S, { className: void 0, children: [
                              e("email.fields.last_name.title"),
                              " ",
                              /* @__PURE__ */ i("span", { "aria-hidden": "true", children: "*" }),
                              " "
                            ] }),
                            /* @__PURE__ */ n(_, { className: void 0, children: [
                              /* @__PURE__ */ i(
                                R,
                                {
                                  id: "lastName",
                                  name: "lastName",
                                  value: this.state.lastName.value,
                                  onChange: this.handleOnChange,
                                  "aria-required": "true",
                                  ref: this.fieldRefs.lastName
                                }
                              ),
                              this.state.lastName.error ? /* @__PURE__ */ i(N, { children: this.state.lastName.errorMessage }) : null
                            ] })
                          ] })
                        }
                      )
                    ] }),
                    /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i(
                      h,
                      {
                        paddingRight: "5",
                        span: 12,
                        spanXs: 12,
                        spanSm: 12,
                        spanMd: 12,
                        spanLg: 12,
                        children: /* @__PURE__ */ n(v, { children: [
                          /* @__PURE__ */ n(S, { className: void 0, children: [
                            e("email.fields.email.title"),
                            /* @__PURE__ */ i("span", { "aria-hidden": "true", children: "*" })
                          ] }),
                          /* @__PURE__ */ n(_, { className: void 0, children: [
                            /* @__PURE__ */ i(
                              R,
                              {
                                id: "email",
                                name: "email",
                                value: this.state.email.value,
                                onChange: this.handleOnChange,
                                "aria-required": "true",
                                ref: this.fieldRefs.email
                              }
                            ),
                            this.state.email.error ? /* @__PURE__ */ i(N, { children: this.state.email.errorMessage }) : null
                          ] })
                        ] })
                      }
                    ) }),
                    /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i(
                      h,
                      {
                        paddingRight: "5",
                        span: 12,
                        spanXs: 12,
                        spanSm: 12,
                        spanMd: 12,
                        spanLg: 12,
                        children: /* @__PURE__ */ n(v, { children: [
                          /* @__PURE__ */ i(S, { className: void 0, children: e("email.fields.phone_number.title") }),
                          /* @__PURE__ */ n(_, { className: void 0, children: [
                            /* @__PURE__ */ i(
                              R,
                              {
                                id: "phoneNumber",
                                name: "phoneNumber",
                                value: this.state.phoneNumber.value,
                                onChange: this.handleOnChange,
                                ref: this.fieldRefs.phoneNumber
                              }
                            ),
                            this.state.phoneNumber.error ? /* @__PURE__ */ i(N, { children: this.state.phoneNumber.errorMessage }) : null
                          ] })
                        ] })
                      }
                    ) }),
                    /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i(
                      h,
                      {
                        paddingRight: "5",
                        span: 12,
                        spanXs: 12,
                        spanSm: 12,
                        spanMd: 12,
                        spanLg: 12,
                        children: /* @__PURE__ */ n(v, { children: [
                          /* @__PURE__ */ i(S, { className: void 0, children: e("email.fields.company_name.title") }),
                          /* @__PURE__ */ n(_, { className: void 0, children: [
                            /* @__PURE__ */ i(
                              R,
                              {
                                id: "company",
                                name: "company",
                                value: this.state.company.value,
                                onChange: this.handleOnChange,
                                ref: this.fieldRefs.company
                              }
                            ),
                            this.state.company.error ? /* @__PURE__ */ i(N, { children: this.state.company.errorMessage }) : null
                          ] })
                        ] })
                      }
                    ) }),
                    /* @__PURE__ */ i(c, { children: /* @__PURE__ */ i(
                      h,
                      {
                        paddingRight: "5",
                        span: 12,
                        spanXs: 12,
                        spanSm: 12,
                        spanMd: 12,
                        spanLg: 12,
                        children: /* @__PURE__ */ n(v, { children: [
                          /* @__PURE__ */ n(S, { className: void 0, children: [
                            e("email.fields.comments.title"),
                            /* @__PURE__ */ i("span", { "aria-hidden": "true", children: "*" })
                          ] }),
                          /* @__PURE__ */ n(_, { className: void 0, children: [
                            /* @__PURE__ */ i(
                              se,
                              {
                                id: "comment",
                                name: "comment",
                                value: this.state.comment.value,
                                rows: 5,
                                maxLength: 1e3,
                                onChange: this.handleOnChange,
                                fullWidth: !0,
                                "aria-required": "true",
                                resize: "vertical",
                                ref: this.fieldRefs.comment
                              }
                            ),
                            this.state.comment.error ? /* @__PURE__ */ i(N, { children: this.state.comment.errorMessage }) : null,
                            /* @__PURE__ */ n(ae, { children: [
                              this.state.comment.value.length,
                              "/1000"
                            ] })
                          ] })
                        ] })
                      }
                    ) }),
                    this.state.fileListUI,
                    /* @__PURE__ */ i(c, { children: /* @__PURE__ */ n(
                      h,
                      {
                        paddingRight: "5",
                        span: 12,
                        spanXs: 12,
                        spanSm: 12,
                        spanMd: 12,
                        spanLg: 12,
                        children: [
                          /* @__PURE__ */ i(O, { children: /* @__PURE__ */ i(c, { children: /* @__PURE__ */ n(T, { alignItems: "center", justifyContent: "center", children: [
                            /* @__PURE__ */ n(h, { span: 3, children: [
                              /* @__PURE__ */ i(
                                F,
                                {
                                  type: "button",
                                  className: "attach-files-button",
                                  width: "standard",
                                  "aria-label": e("email.buttons.attach_files.title"),
                                  onClick: this.handleUpload,
                                  children: e("email.buttons.attach_files.title")
                                }
                              ),
                              /* @__PURE__ */ i(
                                "input",
                                {
                                  style: { display: "none" },
                                  id: "file",
                                  "aria-label": e("email.buttons.attach_files.title"),
                                  className: H({
                                    undefined: !0,
                                    textbutton: !0,
                                    "textbutton-skin-secondary": !0
                                  }),
                                  name: "file",
                                  size: 20,
                                  type: "file",
                                  onChange: this.handleOnChange
                                }
                              )
                            ] }),
                            /* @__PURE__ */ i(h, { span: 9, children: /* @__PURE__ */ i("p", { className: void 0, children: e("email.buttons.attach_files.comment") }) })
                          ] }) }) }),
                          this.state.inputError
                        ]
                      }
                    ) })
                  ] }),
                  /* @__PURE__ */ i(ne, { mt: 6, mb: 6 }),
                  /* @__PURE__ */ i(c, { children: /* @__PURE__ */ n(
                    h,
                    {
                      paddingRight: "5",
                      span: 12,
                      spanXs: 12,
                      spanSm: 12,
                      spanMd: 12,
                      spanLg: 12,
                      children: [
                        /* @__PURE__ */ i(
                          F,
                          {
                            skin: m ? "secondary" : "primary",
                            id: "submitbtn",
                            "aria-label": e(m ? "email.buttons.send_email.alternate_title" : "email.buttons.send_email.title"),
                            width: "standard",
                            type: "submit",
                            value: "Send",
                            children: e(m ? "email.buttons.send_email.alternate_title" : "email.buttons.send_email.title")
                          }
                        ),
                        /* @__PURE__ */ i("p", { className: void 0, children: e("email.fields.comments.security") })
                      ]
                    }
                  ) })
                ] }) })
              }
            ) }) })
          ] })
        ] }) })
      ] })
    ] }) }) }) }) }) });
  }
}
const ye = (y) => {
  const { t: f } = K(), { getRecaptchaToken: e } = G();
  return /* @__PURE__ */ i(re, { ...y, t: f, getRecaptchaToken: e });
};
export {
  ye as default
};
//# sourceMappingURL=contact-channels17.js.map
